import React from "react";
import { Card, CardHeader, CardBody, CardFooter } from "reactstrap";

const DaySkeletonCard = () => {
  return (
    <Card className="border border-secondary">
      <CardHeader className="px-2 py-1">
        <div className="d-flex justify-content-between align-items-center">
          <div className="placeholder-glow">
            <span className="placeholder col-4"></span>
          </div>
          <div className="form-check form-switch form-switch-lg">
            <span className="placeholder col-2"></span>
          </div>
        </div>
      </CardHeader>

      <CardBody className="px-3">
        <div className="pb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="placeholder-glow">
              <span className="placeholder col-3"></span>
            </div>
            <div className="placeholder-glow">
              <span className="placeholder col-2"></span>
            </div>
          </div>
          <div className="placeholder-glow mb-3">
            <span className="placeholder col-6"></span>
          </div>
        </div>

        <div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="placeholder-glow">
              <span className="placeholder col-4"></span>
            </div>
            <div className="placeholder-glow">
              <span className="placeholder col-2"></span>
            </div>
          </div>
          <div className="placeholder-glow">
            <span className="placeholder col-5"></span>
          </div>
        </div>
      </CardBody>

      <CardFooter className="p-2">
        <div className="placeholder-glow">
          <span className="placeholder col-6"></span>
        </div>
      </CardFooter>
    </Card>
  );
};

export default DaySkeletonCard;
